import { render, staticRenderFns } from "./VideoPopupMod.vue?vue&type=template&id=7e479722&scoped=true"
import script from "./VideoPopupMod.vue?vue&type=script&lang=js"
export * from "./VideoPopupMod.vue?vue&type=script&lang=js"
import style0 from "./VideoPopupMod.vue?vue&type=style&index=0&id=7e479722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e479722",
  null
  
)

export default component.exports